var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form bid_form" },
    [
      _c("v-modal-contents", {
        ref: "modal_contents_agree",
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title mt-30  " }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Пользовательское соглашение!"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("p", { staticClass: "red" }, [
                    _vm._v("ТЕКСТ НАХОДИТСЯ В РАЗРАБОТКЕ"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "px-30 btn_bordered ",
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal_contents_agree.modal_open()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Прочитал\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("v-modal-contents", {
        ref: "modal_contents_successfully",
        staticClass: "modal_contents_successfully",
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title mt-30 pl-3 " }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Статус отправки!"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("p", { staticClass: "green_messs" }, [
                    _vm._v("Сообщение отправлено!"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "nr_container_content" }, [
        _c(
          "div",
          { staticClass: "form__inner" },
          [
            _vm._t("sm-title"),
            _vm._v(" "),
            _c(
              "v-form",
              {
                ref: "form_inner",
                staticClass: "form__content",
                attrs: { "lazy-validation": "" },
                model: {
                  value: _vm.valid,
                  callback: function ($$v) {
                    _vm.valid = $$v
                  },
                  expression: "valid",
                },
              },
              [
                _c("div", { staticClass: "form__container" }, [
                  _c("h2", { staticClass: "formNew_h2" }, [
                    _vm._v(
                      "Напишите нам – и мы подберем оптимальное решение для вашего бизнеса"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "form__box" },
                      [
                        _c("v-text-field", {
                          staticClass: "form__input",
                          attrs: { rules: _vm.nameRules },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                                    ФИО *\n                                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.name,
                            callback: function ($$v) {
                              _vm.name = $$v
                            },
                            expression: "name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form__box" },
                      [
                        _c("v-text-field", {
                          staticClass: "form__input",
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                                    Компания\n                                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.company,
                            callback: function ($$v) {
                              _vm.company = $$v
                            },
                            expression: "company",
                          },
                        }),
                        _vm._v(" "),
                        _c("v-text-field", {
                          staticClass: "form__input",
                          attrs: { rules: _vm.cityRules },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                                    Город *\n                                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.city,
                            callback: function ($$v) {
                              _vm.city = $$v
                            },
                            expression: "city",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form__box" },
                      [
                        _c("v-text-field", {
                          staticClass: "form__input",
                          attrs: { rules: _vm.tel_Rules },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                                    Телефон\n                                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.tel,
                            callback: function ($$v) {
                              _vm.tel = $$v
                            },
                            expression: "tel",
                          },
                        }),
                        _vm._v(" "),
                        _c("v-text-field", {
                          staticClass: "form__input",
                          attrs: { rules: _vm.mailRules },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                                    Электронная почта *\n                                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.mail,
                            callback: function ($$v) {
                              _vm.mail = $$v
                            },
                            expression: "mail",
                          },
                        }),
                        _vm._v(" "),
                        _vm.show == 1
                          ? _c("v-select", {
                              staticClass:
                                "cat_items align-items-center d-flex",
                              attrs: {
                                items: _vm.cat_items,
                                "menu-props": {
                                  contentClass: "wrapper_cat_items",
                                },
                                "item-value": "sel_id",
                                label: "Категория товара *",
                                "append-icon": "mdi mdi-chevron-down",
                                rules: _vm.cat_itemsRules,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "selection",
                                    fn: function (data) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(data.item.name)),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(data.item.name)),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                861599068
                              ),
                              model: {
                                value: _vm.defaultСatSelected.sel_id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.defaultСatSelected,
                                    "sel_id",
                                    $$v
                                  )
                                },
                                expression: "defaultСatSelected.sel_id",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form__box" },
                      [
                        _c("v-textarea", {
                          staticClass: "form__input",
                          attrs: { rows: "2", "no-resize": "" },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                                    Обращение\n                                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.message,
                            callback: function ($$v) {
                              _vm.message = $$v
                            },
                            expression: "message",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-12ы" }, [
                      _c("div", {
                        staticClass: "w-100 mt-30",
                        class: _vm.captchaPassed ? "" : "error-captcha",
                        attrs: { id: "captcha-container" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "formNew_wrap__item  mt-30" },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              rules: [
                                function (v) {
                                  return !!v || "Это обязательный пункт"
                                },
                              ],
                              required: "",
                              color: "red",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "customLabelForm" },
                                      [
                                        _vm._v(
                                          "\n                                            Я выражаю согласие с "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "javascript:void(0);",
                                              target: "_blank",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$refs.modal_contents_agree.modal_open(
                                                  "scroll_false"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "условиями\n                                            использования"
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          " моих персональных данных для обработки данного\n                                            обращения\n                                          ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю согласие с\n                                            "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "position-relative zi-1",
                                            attrs: { href: _vm.policy },
                                            on: {
                                              click: function ($event) {
                                                return _vm.linkOpen(_vm.policy)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                Политикой конфиденциальности"
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          " и\n                                            "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "position-relative zi-1",
                                            attrs: { href: _vm.agreement },
                                            on: {
                                              click: function ($event) {
                                                return _vm.linkOpen(
                                                  _vm.agreement
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                Пользовательским соглашением.\n                                            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.checkbox,
                              callback: function ($$v) {
                                _vm.checkbox = $$v
                              },
                              expression: "checkbox",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-checkbox", {
                            staticClass: "mt-0",
                            attrs: { color: "red" },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "customLabelForm" },
                                      [
                                        _vm._v(
                                          "\n                                            Я выражаю согласие на информирование меня о продуктах, акциях, выгодных\n                                            предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2) и\n                                            партнеров.\n                                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.consentToInform,
                              callback: function ($$v) {
                                _vm.consentToInform = $$v
                              },
                              expression: "consentToInform",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "btn_form d-flex align-items-center  ",
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-red w-mc",
                                  attrs: { disabled: !_vm.valid },
                                  on: { click: _vm.send_form },
                                },
                                [
                                  _vm._v(
                                    "\n                                        Отправить\n                                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }